// @ts-nocheck

import React, { useLayoutEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import { MyMatchDotsBackgroundImgPath } from '../../assets/img/mymatch';
import { ON_MY_MATCH_TOGGLE_TRANSITION_DURATION } from '../../constants/ui/mymatch';
import { withOpacity } from '../../styled-components/dark/helpers';
import { MyMatchDynamicBackground as MyMatchDynamicBackgroundTheme } from '../../styled-components/dark/mymatch';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
  border-radius: inherit;

  z-index: 0;

  transition: background ${ON_MY_MATCH_TOGGLE_TRANSITION_DURATION}ms ease-in-out;
`;

const BackgroundRadialGradientWrapper = styled.div`
  position: absolute;
  width: 200%;
  padding-bottom: 100%;
  border-radius: inherit;

  transition: none ${ON_MY_MATCH_TOGGLE_TRANSITION_DURATION}ms ease-in-out;
  transition-property: transform, opacity;
  will-change: opacity, background-position;

  z-index: 2;

  ${({ $isActive }) =>
    $isActive
      ? css`
          opacity: 1;
          transform: translate(0, 0);
        `
      : css`
          opacity: 0;
          transform: translate(0, 100%);
        `};
`;

export const MyMatchDynamicBackgroundRadialClassName = 'my-match-dynamic-background-radial-gradient';
const BackgroundRadialGradient = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background-size: 50%;

  background-image: var(
    --MyMatchDynamicBackgroundRadial-backgroundImage,
    radial-gradient(
      ${withOpacity(MyMatchDynamicBackgroundTheme.mainColor, 'ee')},
      ${withOpacity(MyMatchDynamicBackgroundTheme.mainColor, '11')} 60%,
      transparent 70%,
      transparent
    )
  );
  background-repeat: no-repeat;
`;

const BackgroundLinearGradient = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  border-radius: inherit;
  background-image: linear-gradient(
      to right,
      ${withOpacity(MyMatchDynamicBackgroundTheme.mainColor, '11')} 33%,
      transparent 66%,
      transparent 100%
    ),
    linear-gradient(
      to right,
      black 33%,
      var(--MyMatchDynamicBackground-defaultBackgroundColor, black) 66%,
      var(--MyMatchDynamicBackground-defaultBackgroundColor, black) 100%
    );

  background-size: 300%;
  background-repeat: no-repeat;
  background-position: 0%;
  transition: background-position ${ON_MY_MATCH_TOGGLE_TRANSITION_DURATION * 0.67}ms ease-in-out;

  z-index: 1;

  ${({ $isActive }) =>
    $isActive
      ? css`
          background-position: 0%;
        `
      : css`
          background-position: 100%;
        `};
`;

const BackgroundImageCss = css`
  position: absolute;
  width: 100%;
  height: 100%;

  border-radius: inherit;
  background-image: url(${MyMatchDotsBackgroundImgPath});
  background-size: 150%;
  background-position: center top;
  background-repeat: repeat;

  transition: none ${ON_MY_MATCH_TOGGLE_TRANSITION_DURATION * 0.4}ms ease-in-out;
  transition-property: transform, opacity;
  z-index: 2;

  ${({ $isActive }) =>
    $isActive
      ? css`
          opacity: 1;
        `
      : css`
          opacity: 0;
        `};
`;
export const MyMatchDynamicBackgroundLeftImgClassName = 'my-match-dynamic-background-left-img';
const BackgroundImageLeft = styled.div`
  ${BackgroundImageCss}
  height: calc(100% - 2em);

  transform: translate(-50%, 2em);
`;

export const MyMatchDynamicBackgroundRightImgClassName = 'my-match-dynamic-background-right-img';
const BackgroundImageRight = styled.div`
  ${BackgroundImageCss}
  height: calc(100% + 13em);

  transform: translate(50%, -13em);
`;

type MyMatchDynamicBackgroundProps = {
  className?: string;
  isActive?: boolean;
};

const MyMatchDynamicBackground = ({ className = '', isActive = false }: MyMatchDynamicBackgroundProps) => {
  const [shouldRender, setShouldRender] = useState(false);

  useLayoutEffect(() => {
    const tmo = setTimeout(() => {
      setShouldRender(true);
    }, 0);

    return () => {
      clearTimeout(tmo);
    };
  }, []);

  return shouldRender ? (
    <Wrapper className={className} $isActive={isActive}>
      <BackgroundImageLeft className={MyMatchDynamicBackgroundLeftImgClassName} $isActive={isActive} />
      <BackgroundImageRight className={MyMatchDynamicBackgroundRightImgClassName} $isActive={isActive} />
      <BackgroundRadialGradientWrapper className={MyMatchDynamicBackgroundRadialClassName} $isActive={isActive}>
        <BackgroundRadialGradient $isActive={isActive} />
      </BackgroundRadialGradientWrapper>
      <BackgroundLinearGradient $isActive={isActive} />
    </Wrapper>
  ) : null;
};

export default MyMatchDynamicBackground;
